import "bootstrap/dist/css/bootstrap.min.css";

const LoadingPage = () => {
    return (
    <div className="d-flex align-items-center justify-content-center vh-100">
        <div className="text-center text-white">
            <h1 className="display-1 fw-bold">Loading...</h1>
            <p className="lead">
                The page you requested is loading. Please wait a moment.
              </p>
        </div>
    </div>
    )
}

export default LoadingPage;
